import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import * as Styles from './ProductImage.scss';

interface IOwnProps {
  onClick: {
    uri?: string;
    action?: (event: React.SyntheticEvent<HTMLElement>) => void;
  };
  src: string;
  alt: string;
  isClickable?: boolean;
}

const ProductImage: React.SFC<IOwnProps> = ({ onClick, src, alt, isClickable }) => {
  const { uri, action } = onClick;

  const imageLinkClassNames = cx({
    [Styles.imageLink]: true,
    [Styles.noClickable]: !isClickable,
  });

  return (
    <Fragment>
      {uri && (
        <a className={imageLinkClassNames} href={onClick.uri}>
          <img className={Styles.image} src={src} alt={alt} />
        </a>
      )}
      {action && (
        <div className={imageLinkClassNames} onClick={onClick.action}>
          <img className={Styles.image} src={src} alt={alt} />
        </div>
      )}
    </Fragment>
  );
};

export default ProductImage;
